<div class="row mt-n1">
    <div class="col-md-12">
        <div class="card card-accent-success animated fadeIn">
            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                <div class="card-header-buscador">
                    <i class="fa fa-file-text-o"></i> Comentarios de la U.I.
                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                </div>
            </a>
            <div class="card-body-detalle pb-3">

                <div *ngFor="let comentarioUI of comentariosUI" class="row">
                    <div class="col-12">
                        <div class="card observacion">
                            <div class="card-title">
                                <div class="row">
                                    <div class="d-flex justify-content-start col-9">
                                        <span class="ms-2 col-form-label">{{ comentarioUI?.Usuario }}</span>
                                    </div>
                                    <div class="d-flex justify-content-end col-w20">
                                        <div class="text-end me-2 pt-2">
                                            <i class="fa fa-calendar text-muted"></i> <small class="text-muted">{{ comentarioUI?.Fecha | date:'dd/MM/yyyy HH:mm' }}</small>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end col-w4">
                                        <button *ngIf="hasDeletingAccess" (click)="onDelete(comentarioUI)" type="button" class="btn btn-sm btn-danger" title="Eliminar">
                                            <span class="fa fa-remove"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row pb-2">
                                <p class="ms-2 card-text">{{ comentarioUI?.Observaciones }}</p> 
                            </div>
                        </div>
                    </div>
                </div>

                <div class="empty-grid" *ngIf="comentariosUI?.length === 0">No se ha encontrado ningún registro</div>
            </div>
        </div>
    </div>
</div>
